import { render, staticRenderFns } from "./CarrierIcon.vue?vue&type=template&id=e4a00cde&scoped=true&"
import script from "./CarrierIcon.vue?vue&type=script&lang=js&"
export * from "./CarrierIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a00cde",
  null
  
)

export default component.exports